export const getAuthToken = () => localStorage.getItem('auth_token');
